import { isError } from "@faire/typescript";

export class UnknownError extends Error {
  constructor(error?: unknown) {
    if (isError(error)) {
      // If the value is already an Error, reuse it instead of creating a new Error
      return error;
    } else if (typeof error === "string") {
      super(error);
    } else {
      try {
        super(`An unknown error occurred: ${String(error)}`);
      } catch {
        super(`An unknown error occurred.`);
      }
    }
    this.name = "UnknownError";
  }
}
